type CityInput =
  | {
      name?: string | null;
      countrySubdivision?: { name?: string | null } | null;
    }
  | null
  | undefined;

/**
 * Builds a "City, Subdivision" display location string.
 * Falls back to the provided address string if city data is incomplete.
 */
export function buildDisplayLocation(city: CityInput, fallback?: string | null): string | null {
  if (city?.name && city?.countrySubdivision?.name) {
    return `${city.name}, ${city.countrySubdivision.name}`;
  }
  return fallback || null;
}
